import { render, staticRenderFns } from "./answerpeople.vue?vue&type=template&id=23bd8a5b"
import script from "./answerpeople.vue?vue&type=script&lang=js"
export * from "./answerpeople.vue?vue&type=script&lang=js"
import style0 from "./answerpeople.vue?vue&type=style&index=0&id=23bd8a5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports